import { render, staticRenderFns } from "./EmailConfirmationView.vue?vue&type=template&id=3c8165df&scoped=true&"
import script from "./EmailConfirmationView.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8165df",
  null
  
)

export default component.exports